// eslint-disable-next-line import/no-extraneous-dependencies

import { attributes } from './attributes';
import { findElement } from './find-element';
export function findPlaceholder(contextId) {
  return findElement({
    attribute: attributes.placeholder.contextId,
    value: contextId
  });
}